import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "style_tab",
  class: "my-6"
}
const _hoisted_2 = {
  key: 1,
  class: "tab-wrapper-primary"
}
const _hoisted_3 = { class: "tab-heading-primary" }
const _hoisted_4 = { class: "p-6" }
const _hoisted_5 = { class: "relative grid grid-cols-2 gap-4 pb-4" }
const _hoisted_6 = { class: "grid grid-cols-2 gap-4 py-4 border-t-[1px]" }
const _hoisted_7 = { class: "grid grid-cols-2 gap-4 py-4 border-t-[1px] border-dashed" }
const _hoisted_8 = { class: "grid grid-cols-2 gap-4 py-4 border-t-[1px] border-dashed" }
const _hoisted_9 = { class: "grid grid-cols-2 gap-4 py-4 border-t-[1px] border-dashed" }
const _hoisted_10 = { class: "w-full pt-4 border-t-[1px]" }
const _hoisted_11 = { class: "relative pt-2" }
const _hoisted_12 = {
  class: "label-primary flex gap-1",
  for: ""
}
const _hoisted_13 = ["placeholder"]
const _hoisted_14 = {
  key: 2,
  class: "tab-wrapper-primary mt-6"
}
const _hoisted_15 = { class: "tab-heading-primary" }
const _hoisted_16 = { class: "p-6" }
const _hoisted_17 = { class: "flex items-center gap-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-medium text-gray-900" }, "Replace TBA rate text", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-neutral-100 mt-1" }, " When enabled, all TBA rate labels on the widget will display your custom text instead. ", -1)
const _hoisted_20 = {
  key: 0,
  class: "mt-3 flex flex-col gap-4"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  class: "label-primary",
  for: "tba-custom-text"
}, " TBA rate label ", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-neutral-100 mb-1" }, "Replaces the \"TBA\" text shown on unpriced rates.", -1)
const _hoisted_23 = ["placeholder"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", {
  class: "label-primary",
  for: "tba-custom-subtext"
}, " TBA rate subtext ", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-neutral-100 mb-1" }, "Replaces the \"contact us for pricing\" text shown below unpriced rates.", -1)
const _hoisted_26 = ["placeholder"]
const _hoisted_27 = {
  key: 3,
  class: "h-[600px] w-full text-center",
  role: "status"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NotificationPopup = _resolveComponent("NotificationPopup")!
  const _component_SelectColor = _resolveComponent("SelectColor")!
  const _component_DropdownMenu = _resolveComponent("DropdownMenu")!
  const _component_TooltipIcon = _resolveComponent("TooltipIcon")!
  const _component_BaseTooltip = _resolveComponent("BaseTooltip")!
  const _component_CheckboxSlide = _resolveComponent("CheckboxSlide")!
  const _component_LoadingIcon = _resolveComponent("LoadingIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.widget.edited)
      ? (_openBlock(), _createBlock(_component_NotificationPopup, {
          key: 0,
          status: "warning",
          title: "Changes Unpublished",
          text: "To view your updates on the widget, please save and publish them.",
          class: "mb-6"
        }))
      : _createCommentVNode("", true),
    (_ctx.widget.config)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.changeCase('customise design', _ctx.ElementE.TITLE)), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_SelectColor, {
                value: _ctx.widget.config?.link_style,
                label: "Link colour",
                onColors: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setColor($event, 'link_style')))
              }, null, 8, ["value"]),
              _createVNode(_component_SelectColor, {
                value: _ctx.widget.config?.link_hover_colour,
                label: "Link hover colour",
                onColors: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setColor($event, 'link_hover_colour')))
              }, null, 8, ["value"]),
              _createVNode(_component_SelectColor, {
                value: _ctx.widget.config?.button_colour,
                label: "Button colour",
                onColors: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setColor($event, 'button_colour')))
              }, null, 8, ["value"]),
              _createVNode(_component_SelectColor, {
                value: _ctx.widget.config?.button_hover_colour,
                label: "Button hover colour",
                onColors: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setColor($event, 'button_hover_colour')))
              }, null, 8, ["value"]),
              _createVNode(_component_SelectColor, {
                value: _ctx.widget.config?.button_text_colour,
                label: "Button text colour",
                onColors: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setColor($event, 'button_text_colour')))
              }, null, 8, ["value"]),
              _createVNode(_component_SelectColor, {
                value: _ctx.widget.config?.button_hover_text_colour,
                label: "Button hover text colour",
                onColors: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setColor($event, 'button_hover_text_colour')))
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_SelectColor, {
                value: _ctx.widget.config?.deal_btn_bg_colour,
                "is-change-case": false,
                label: "“Deals for you” button colour",
                onColors: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setColor($event, 'deal_btn_bg_colour')))
              }, null, 8, ["value"]),
              _createVNode(_component_SelectColor, {
                value: _ctx.widget.config?.deal_btn_text_colour,
                "is-change-case": false,
                label: "“Deals for you” button text colour",
                onColors: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setColor($event, 'deal_btn_text_colour')))
              }, null, 8, ["value"]),
              _createVNode(_component_SelectColor, {
                value: _ctx.widget.config?.deal_btn_hover_colour,
                "is-change-case": false,
                label: "“Deals for you” button hover colour",
                onColors: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setColor($event, 'deal_btn_hover_colour')))
              }, null, 8, ["value"]),
              _createVNode(_component_SelectColor, {
                value: _ctx.widget.config?.deal_btn_text_hover_colour,
                "is-change-case": false,
                label: "“Deals for you” button hover text colour",
                onColors: _cache[9] || (_cache[9] = ($event: any) => (_ctx.setColor($event, 'deal_btn_text_hover_colour')))
              }, null, 8, ["value"]),
              _createVNode(_component_DropdownMenu, {
                values: _ctx.iconsList,
                label: "“Deals for you” icon",
                "default-select": _ctx.widget.config?.deal_icon_colour || 'PriceTag',
                "is-change-case": false,
                type: _ctx.DropdownTypeE.ICON,
                onSelect: _ctx.cnangeIcon
              }, null, 8, ["values", "default-select", "type", "onSelect"]),
              _createVNode(_component_SelectColor, {
                value: _ctx.widget.config?.deal_matrix_icon_colour,
                "is-change-case": false,
                label: "“Deals for you” you icon colour (in matrix-cells)",
                onColors: _cache[10] || (_cache[10] = ($event: any) => (_ctx.setColor($event, 'deal_matrix_icon_colour')))
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_SelectColor, {
                value: _ctx.widget.config?.minlos_bg_colour,
                "is-change-case": false,
                label: "MinLOS banner background colour",
                onColors: _cache[11] || (_cache[11] = ($event: any) => (_ctx.setColor($event, 'minlos_bg_colour')))
              }, null, 8, ["value"]),
              _createVNode(_component_SelectColor, {
                value: _ctx.widget.config?.minlos_text_colour,
                "is-change-case": false,
                label: "MinLOS banner text colour",
                onColors: _cache[12] || (_cache[12] = ($event: any) => (_ctx.setColor($event, 'minlos_text_colour')))
              }, null, 8, ["value"]),
              _createVNode(_component_SelectColor, {
                value: _ctx.widget.config?.special_banner_bg_color,
                "is-change-case": false,
                label: "Specials background colour",
                onColors: _cache[13] || (_cache[13] = ($event: any) => (_ctx.setColor($event, 'special_banner_bg_color')))
              }, null, 8, ["value"]),
              _createVNode(_component_SelectColor, {
                value: _ctx.widget.config?.special_banner_text,
                "is-change-case": false,
                label: "Specials text colour",
                onColors: _cache[14] || (_cache[14] = ($event: any) => (_ctx.setColor($event, 'special_banner_text')))
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_SelectColor, {
                value: _ctx.widget.config?.widget_card_bg_colour,
                "is-change-case": false,
                label: "Widget background card colour",
                onColors: _cache[15] || (_cache[15] = ($event: any) => (_ctx.setColor($event, 'widget_card_bg_colour')))
              }, null, 8, ["value"]),
              _createVNode(_component_SelectColor, {
                value: _ctx.widget.config?.widget_card_border_colour,
                "is-change-case": false,
                label: "Widget background card border colour",
                onColors: _cache[16] || (_cache[16] = ($event: any) => (_ctx.setColor($event, 'widget_card_border_colour')))
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_SelectColor, {
                value: _ctx.widget.config?.property_filter_tag_colour,
                "is-change-case": false,
                label: "Property filter tag colour",
                onColors: _cache[17] || (_cache[17] = ($event: any) => (_ctx.setColor($event, 'property_filter_tag_colour')))
              }, null, 8, ["value"]),
              _createVNode(_component_SelectColor, {
                value: _ctx.widget.config?.property_filter_all_tag_colour,
                "is-change-case": false,
                label: "Property filter 'All properties' tag colour",
                onColors: _cache[18] || (_cache[18] = ($event: any) => (_ctx.setColor($event, 'property_filter_all_tag_colour')))
              }, null, 8, ["value"]),
              _createVNode(_component_SelectColor, {
                value: _ctx.widget.config?.property_filter_tag_text_colour,
                "is-change-case": false,
                label: "Property filter tag text colour",
                onColors: _cache[19] || (_cache[19] = ($event: any) => (_ctx.setColor($event, 'property_filter_tag_text_colour')))
              }, null, 8, ["value"]),
              _createVNode(_component_SelectColor, {
                value: _ctx.widget.config?.property_filter_all_tag_text_colour,
                "is-change-case": false,
                label: "Property filter 'All properties' tag text colour",
                onColors: _cache[20] || (_cache[20] = ($event: any) => (_ctx.setColor($event, 'property_filter_all_tag_text_colour')))
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("label", _hoisted_12, [
                  _createTextVNode(" Custom CSS "),
                  _createVNode(_component_BaseTooltip, { "tooltip-text": "For a sample of the custom CSS code, please refer to the developer notes accessible from the menu in the upper right corner" }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_TooltipIcon)
                    ]),
                    _: 1
                  })
                ]),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.custom_css) = $event)),
                  class: "input-primary h-40",
                  placeholder: (_ctx.changeCase('enter code...', _ctx.ElementE.PLACEHOLDER) as string),
                  onInput: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.setCustomCss && _ctx.setCustomCss(...args)))
                }, null, 40, _hoisted_13), [
                  [_vModelText, _ctx.custom_css]
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.widget.config)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.changeCase('custom design - text', _ctx.ElementE.TITLE)), 1),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_CheckboxSlide, {
                label: "",
                isChecked: _ctx.widget.config?.tba_custom_text_enabled ?? false,
                "onUpdate:isChecked": _ctx.toggleTbaCustomText
              }, null, 8, ["isChecked", "onUpdate:isChecked"]),
              _hoisted_18
            ]),
            _hoisted_19,
            (_ctx.widget.config?.tba_custom_text_enabled)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("div", null, [
                    _hoisted_21,
                    _hoisted_22,
                    _withDirectives(_createElementVNode("input", {
                      id: "tba-custom-text",
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.tbaCustomText) = $event)),
                      class: "input-primary block",
                      placeholder: (_ctx.changeCase('e.g. Closed, Private Event', _ctx.ElementE.PLACEHOLDER) as string),
                      onInput: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.setTbaCustomText && _ctx.setTbaCustomText(...args)))
                    }, null, 40, _hoisted_23), [
                      [_vModelText, _ctx.tbaCustomText]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_24,
                    _hoisted_25,
                    _withDirectives(_createElementVNode("input", {
                      id: "tba-custom-subtext",
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.tbaCustomSubtext) = $event)),
                      class: "input-primary block",
                      placeholder: (_ctx.changeCase('e.g. Please enquire directly', _ctx.ElementE.PLACEHOLDER) as string),
                      onInput: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.setTbaCustomSubtext && _ctx.setTbaCustomSubtext(...args)))
                    }, null, 40, _hoisted_26), [
                      [_vModelText, _ctx.tbaCustomSubtext]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _createVNode(_component_LoadingIcon),
          _hoisted_28
        ]))
  ]))
}